<template>
  <div id="navigation">
    <b-navbar class="is-primary">
      <template #brand>
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img
            class="pandora-logo"
            src="@/assets/image/logo.svg"
            alt="Pandora's Logo"
          />
        </b-navbar-item>
      </template>
      <template v-if="isSignedIn" #start>
        <b-navbar-item
          v-for="(route, index) in routeList"
          :key="index"
          tag="router-link"
          :to="{ path: route.path }"
        >
          {{ route.name }}
        </b-navbar-item>
      </template>
      <template #end>
        <HeaderProfile v-if="isSignedIn" />
        <b-navbar-item v-if="!isSignedIn" tag="div">
          <div class="buttons">
            <a class="button is-primary is-light" href="/signup"> 会員登録 </a>
            <a class="button is-primary is-dark" href="/signin"> ログイン </a>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import HeaderProfile from '@/components/HeaderProfile';

export default {
  name: 'Navigation',
  components: {
    HeaderProfile
  },
  computed: {
    isSignedIn() {
      return this.$store.getters['auth/isSignedIn'];
    },
    routeList() {
      return [
        {
          name: '配信一覧',
          path: '/live/explore'
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped></style>
